// VisualizationSlide.js

import React from 'react';
import OverlayUI from './OverlayUI';

const VisualizationSlide = ({ viz, index, currentIndex }) => {
  // A slide is active if its own index matches the current active index.
  const isActive = index === currentIndex;

  console.log(viz.name, viz.url)

  return (
    <div className="visualization-slide">
      <div className="main-content">
        {/*  ↓↓↓ THE KEY CHANGE IS HERE ↓↓↓ */}
        {/* Only render the iframe if this slide is the active one */}
        {isActive && (
          <iframe
            src={viz.url}
            title={viz.name}
            className="slide-iframe"
            allowFullScreen
            sandbox="allow-scripts allow-same-origin allow-popups"
            // Adding a key here helps React to re-mount the iframe correctly
            key={viz.url}
          />
        )}
        <OverlayUI viz={viz} />
      </div>
    </div>
  );
};

export default VisualizationSlide;